export default __webpack_public_path__ + "static/media/샴푸바 클래스_모바일.1415664b.jpg";